export function buildEnterpriseCsvFilename({ from, to, prefix = 'DE-Reconciliation' } = {}) {
  const stamp = new Date().toISOString().slice(0, 10);
  const range = from && to ? `_${from}_to_${to}` : from ? `_from_${from}` : to ? `_to_${to}` : '';
  return `${prefix}${range}_${stamp}.csv`;
}
